module.exports = __webpack_public_path__ + "img/linkedin.664b1d9.svg";